import React from 'react';

import CommonNode from '../../../../components/node/common-node';
import { NodeProvider } from '../../../../context/node-context';
import { getNodeName } from '../../../../utils/getNodeName';
import DedupTaskForm from './forms/dedup-task-form';
import { dedupTaskValidationSchema } from './schema.js';

export default function DataOperationDedupNode({ data, id, type }) {
  const nodeName = getNodeName(data?.name, 'Data Operation Dedup Task');

  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: nodeName,
        altText: 'Data Operation Dedup Task',
        defaultLabel: 'Data Operation Dedup Task',
      }}
    >
      <CommonNode FormComponent={DedupTaskForm} schemaResolver={dedupTaskValidationSchema} />
    </NodeProvider>
  );
}
